import { render, staticRenderFns } from "./futuredelivery.vue?vue&type=template&id=70a88dd6&"
import script from "./futuredelivery.vue?vue&type=script&lang=js&"
export * from "./futuredelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports